import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import StoredPDFContentWithProvider from './ExpandedPDF/StoredPDFContent.js';
import { useResourceDocumentDataContextSafe } from '../context/resourceDataContext.js';
import { useQueryDocumentResourceFileContent } from '../../queries/useQueryDocumentResourceFileContent.js';
import { isResourceDetailDocumentPDF, isResourceDetailDocumentHTML, isResourceDetailDocumentJSON, isResourceDetailDocumentMarkdown, isResourceDetailDocumentText, isResourceDetailDocumentCsv, isResourceDetailDocumentDOCX, isResourceDetailDocumentWithGeneratedPDFPreview } from '../../../resources/documentGuards.js';
import { ResourceMarkdown } from '../ExpandedResource/Content/Document/ResourceMarkdown.js';
import { ResourcePlainText } from '../ExpandedResource/Content/Document/ResourcePlainText.js';
import { ResourceDocx } from '../ExpandedResource/Content/Document/ResourceDocx.js';
import { ResourceCode } from '../ExpandedResource/Content/Document/ResourceCode.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import { Spinner } from '@fabric-app/ui/components/Spinner';
import { maxDocumentPreviewSize } from '../../resource-details.config.js';
import Badge from '@fabric-app/ui/components/Badge';
import FileDisplay from '../../../resources/components/FileDisplay.js';
import { ExpandedFdocElements } from './ExpandedFdocElements.js';
import { DocumentHtmlPreview } from '../DocumentHtmlPreview.js';

const DocumentContent = ({ isFullscreenEnabled, tinyPagesIsVisible }) => {
  const { resource, handleDownload } = useResourceDocumentDataContextSafe();
  const { data: fileContent, isLoading } = useQueryDocumentResourceFileContent(resource, {
    enabled: !isResourceDetailDocumentPDF(resource) && !resource.data.pdfRender?.url
  });
  const isCode = isResourceDetailDocumentHTML(resource) || isResourceDetailDocumentJSON(resource);
  if (isResourceDetailDocumentPDF(resource)) {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [
        /* @__PURE__ */ jsx(StoredPDFContentWithProvider, {
          isFullScreen: isFullscreenEnabled,
          tinyPagesIsVisible
        }),
        /* @__PURE__ */ jsx(DocumentHtmlPreview, {
          resource
        })
      ]
    });
  }
  if (resource.data.pdfRender?.url) {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [
        /* @__PURE__ */ jsx(StoredPDFContentWithProvider, {
          fileUrl: resource.data.pdfRender?.url,
          isFullScreen: isFullscreenEnabled,
          tinyPagesIsVisible
        }),
        /* @__PURE__ */ jsx(DocumentHtmlPreview, {
          resource
        })
      ]
    });
  }
  if (isResourceDetailDocumentMarkdown(resource) && fileContent) {
    return /* @__PURE__ */ jsx(ResourceMarkdown, {});
  }
  if ((isResourceDetailDocumentText(resource) || isResourceDetailDocumentCsv(resource)) && fileContent) {
    return /* @__PURE__ */ jsx(ResourcePlainText, {});
  }
  if (isResourceDetailDocumentDOCX(resource) && fileContent) {
    return /* @__PURE__ */ jsx(ResourceDocx, {});
  }
  if (isCode && fileContent) {
    return /* @__PURE__ */ jsx(ResourceCode, {});
  }
  if (isLoading) {
    return /* @__PURE__ */ jsxs(Flex, {
      alignItems: "center",
      justifyContent: "center",
      flexGrow: true,
      children: [
        /* @__PURE__ */ jsx(Spinner, {}),
        /* @__PURE__ */ jsx(DocumentHtmlPreview, {
          resource
        })
      ]
    });
  }
  return /* @__PURE__ */ jsxs(ExpandedFdocElements.StoredFile, {
    children: [
      !isResourceDetailDocumentWithGeneratedPDFPreview(resource) && (resource.size ?? 0) > maxDocumentPreviewSize && /* @__PURE__ */ jsx(StyledLargeBadge, {
        variant: "bg-primary-reverse",
        size: "medium",
        children: "File is too large to preview"
      }),
      /* @__PURE__ */ jsx(FileDisplay, {
        fileExtension: resource.extension,
        fileName: resource.name || "untitled",
        onClick: handleDownload
      })
    ]
  });
};
const StyledLargeBadge = styled(Badge.Static).withConfig({
  displayName: "DocumentContent__StyledLargeBadge",
  componentId: "sc-4e600ea2-0"
})([
  `opacity:0.5;`
]);

export { DocumentContent };
//# sourceMappingURL=DocumentContent.js.map
